import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import SubmitPanel from 'Components/Admin/Form/components/SubmitPanel/SubmitPanel';
import { adminMessage } from 'Components/Admin/ToastMessage';
import { toast } from 'react-toastify';
import { logger } from 'RootShared/utility/ErrorLogger';

const AdminFormView = ({ children, form, initialValues, tab }) => {
  const handleCancel = () => form.resetForm({ ...initialValues });

  return (
    <>
      {children(form)}
      {form.dirty && (
        <SubmitPanel
          tab={tab}
          onSave={form.submitForm}
          onCancel={handleCancel}
        />
      )}
    </>
  );
};

const AdminForm = ({ children, onSubmit, initialValues, validationSchema, tab }) => {
  const yupSchema = Yup.object().shape(validationSchema);

  const handleSubmit = async (data, form) => {
    try {
      const response = await onSubmit(data);

      form.resetForm({ ...response });
      form.setSubmitting(false);
      adminMessage({
        title: 'Changes have been saved.',
      });
    } catch (error) {
      logger.error(error);
      adminMessage({
        title: 'Oh, something went wrong...',
        message: error.message,
      }, {
        type: toast.TYPE.WARNING,
      });
    }
  };

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={initialValues}
      validationSchema={yupSchema}
    >
      {
        (form) => (
          <AdminFormView
            form={form}
            initialValues={initialValues}
            tab={tab}
          >
            {children}
          </AdminFormView>
        )
      }
    </Formik>
  );
};

export default AdminForm;
